function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.5166,
  cy: 21.0886,
  r: 20.75,
  fill: "#90AFD5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7575 17.2592V25.75H15.5292V21.9458H10.7711V25.75H9.55469V17.2592H10.7711V20.9322H15.5292V17.2592H16.7575Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5101 25.8454C20.8503 25.8454 20.2461 25.758 19.6975 25.5831C19.1569 25.4081 18.6878 25.1458 18.2903 24.796L18.7315 23.8897C19.145 24.2236 19.5743 24.4661 20.0195 24.6171C20.4647 24.7682 20.9655 24.8437 21.5221 24.8437C22.1581 24.8437 22.651 24.7244 23.0008 24.4859C23.3506 24.2474 23.5255 23.9095 23.5255 23.4723C23.5255 23.1066 23.3625 22.8323 23.0366 22.6494C22.7106 22.4586 22.1939 22.2837 21.4863 22.1247C20.8105 21.9816 20.258 21.8186 19.8287 21.6358C19.3994 21.445 19.0615 21.1946 18.815 20.8845C18.5686 20.5665 18.4453 20.161 18.4453 19.6681C18.4453 19.1752 18.5765 18.7419 18.8389 18.3683C19.1012 17.9867 19.4709 17.6925 19.9479 17.4858C20.4329 17.2711 20.9894 17.1638 21.6175 17.1638C22.2137 17.1638 22.7702 17.2552 23.287 17.4381C23.8117 17.621 24.249 17.8793 24.5988 18.2132L24.1575 19.1196C23.768 18.7936 23.3665 18.5551 22.9531 18.404C22.5397 18.245 22.0984 18.1655 21.6294 18.1655C21.0172 18.1655 20.5362 18.2967 20.1864 18.5591C19.8366 18.8135 19.6617 19.1633 19.6617 19.6085C19.6617 19.9901 19.8128 20.2803 20.1149 20.479C20.4249 20.6778 20.9178 20.8567 21.5936 21.0157C22.3012 21.1747 22.8736 21.3416 23.3109 21.5165C23.7481 21.6914 24.0979 21.9299 24.3603 22.2321C24.6226 22.5342 24.7538 22.9237 24.7538 23.4007C24.7538 23.8936 24.6226 24.323 24.3603 24.6887C24.0979 25.0544 23.7203 25.3406 23.2274 25.5473C22.7424 25.746 22.17 25.8454 21.5101 25.8454Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8008 23.6512H27.5077L26.6014 25.75H25.3492L29.1295 17.2592H30.167L33.9593 25.75H32.7071L31.8008 23.6512ZM31.3834 22.6733L29.6543 18.6306L27.9251 22.6733H31.3834Z",
  fill: "white"
});

var SvgHsa = function SvgHsa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHsa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hsa.0057aabb.svg";
export { ForwardRef as ReactComponent };